// extracted by mini-css-extract-plugin
export default {"page":"xX-z","cartModal":"yX-z","checkout":"zX-z","placeholder":"AX-z","account":"BX-z"};